import { useState } from "react";

const empty = { title: "", description: "", priority: "Medium", status: "Todo", dueDate: "" };

export default function TaskForm({ initial = empty, onSubmit, onCancel }) {
  const [form, setForm] = useState(initial);

  const handle = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = (e) => {
    e.preventDefault();
    if (!form.title.trim()) return;
    onSubmit(form);
  };

  return (
    <form onSubmit={submit} className="space-y-3">
      <input name="title" value={form.title} onChange={handle} placeholder="Task title"
        className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400" required />
      <textarea name="description" value={form.description} onChange={handle} placeholder="Description"
        className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400" rows={3} />
      <div className="flex gap-3">
        <select name="priority" value={form.priority} onChange={handle}
          className="flex-1 border rounded px-3 py-2">
          {["Low", "Medium", "High"].map((p) => <option key={p}>{p}</option>)}
        </select>
        <select name="status" value={form.status} onChange={handle}
          className="flex-1 border rounded px-3 py-2">
          {["Todo", "In Progress", "Done"].map((s) => <option key={s}>{s}</option>)}
        </select>
        <input type="date" name="dueDate" value={form.dueDate} onChange={handle}
          className="flex-1 border rounded px-3 py-2" />
      </div>
      <div className="flex gap-2 justify-end">
        {onCancel && <button type="button" onClick={onCancel}
          className="px-4 py-2 rounded border hover:bg-gray-100">Cancel</button>}
        <button type="submit"
          className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700">Save</button>
      </div>
    </form>
  );
}
